import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { Icon, message, Checkbox, InputNumber, DatePicker, Collapse, Tooltip, Card } from 'antd';
import { getPropEventsForEvent, makePropEvent } from "../../api-calls/events"
import { makeEvent as makeContractEvent } from "../../contract/Events"
import Modal from 'react-modal'
import { duration } from 'moment';
import { registerOracle } from "../../contract/OraclesController"
import { registerOracle as registerOracleApi } from '../../api-calls/oracles'
import AvailablePropBets from "../layoutComponents/AvailablePropBets"
import OracleRegNotice from "../layoutComponents/OracleRegNotice"
const mvuMultiplier = 100000;
const ethMultiplier = 1000000000000000000;
const roundingMultiplier = 1000000000;

@observer(["AuthStore", "ViewStore", "eventStore", "AdminStore", "WagerStore", "BetSlipStore", "web3Store", "CustomRouter", "UserStore", "TeamStore", "CategoriesStore"])

export default class OraclePropBets extends Component {

    constructor(props) {
        super(props);

        this.state = {
            finalRender: <div />,
            loaded: false,
            loading: true,
            modalVisible: false,
            newBetTitle: "",
            newBetOptionOne: "",
            newBetOptionTwo: "",
            optionOneBytesId: "",
            optionTwoBytesId: "",
            drawBytesId: "0x6472617700000000000000000000000000",
            newBetDuration: 0,
            drawPossible: false,
            officialStart: this.props.originalEvent.startTime,
            makerBond: 10000,
            oracleModalVisible: false,
            oracleOneBackground: "#041827",
            oracleTwoBackground: "#041827",
            chosenOracleTeam: null,
            oracleStake: 0,
            registered: false,
            currentPropBet: {propTitle: "",teams: ["",""]},
            oracleStatus: false
          
        }
        this.renderBetsForOneType = this.renderBetsForOneType.bind(this);
        this.renderBetsForOneType = this.renderBetsForOneType.bind(this);
        this.showOracleModal = this.showOracleModal.bind(this);
        this.handleOracleOk = this.handleOracleOk.bind(this);
        this.handleOracleCancel = this.handleOracleCancel.bind(this);
        this.oracleTeamOneClicked = this.oracleTeamOneClicked.bind(this);
        this.oracleTeamTwoClicked = this.oracleTeamTwoClicked.bind(this);



    }

    oracleTeamOneClicked() {
        this.setState({
            oracleTwoBackground: "#041827",
            oracleOneBackground: "#1890ff",
            chosenOracleTeam: 1
        });

    }

    oracleTeamTwoClicked() {
        this.setState({
            oracleOneBackground: "#041827",
            oracleTwoBackground: "#1890ff",
            chosenOracleTeam: 2
        });
    }


    componentDidMount() {
        const { AdminStore, ViewStore } = this.props;
        if (!this.state.loaded && this.state.loading) {
            this.setState({ finalRender: <Icon type="loading" /> })
        }
        this.setState({ oracleStatus: AdminStore.oracleStatus });
      
        this.renderPropBetTypes();
    }

    showOracleModal = (teamChosen, propBetChosen) => {
        if (this.state.oracleStatus) {
            this.setState({
                oracleModalVisible: true,               
                currentPropBet: propBetChosen

            });
             (teamChosen == 1 ? this.oracleTeamOneClicked() : this.oracleTeamTwoClicked());
        } else {
            message.warning("You are not verified as an Oracle.");
        }
    }

    handleOracleCancel = (e) => {
        console.log(e);
        this.setState({
            oracleModalVisible: false,
        });
    }

    handleOracleOk = (e) => {
        const { CustomRouter } = this.props;
        const { eventStore, AuthStore, AdminStore, web3Store } = this.props;
        const { router: { params } } = CustomRouter;
        console.log(e);

        let self = this;
        if (this.state.chosenOracleTeam == null) {
            message.info("You must choose a winning team!");
        } else {
            if (this.state.oracleStake == 0 || isNaN(this.state.oracleStake)) {
                message.info("You must meet the minimum oracle stake which is " + AdminStore.minOracleStake + " MVU");
            } else {
                this.setState({
                    oracleModalVisible: false,
                });

                let eventBytes32Id = this.state.currentPropBet.bytes32Id;
                let mvuStake = Number(this.state.oracleStake) * mvuMultiplier;
                let winnerVote = this.state.chosenOracleTeam;

                console.log("event ID " + self.props.event_id);
                console.log("bytes ID " + self.props.bytes32_id);
                console.log("stake " + mvuStake);
                console.log("vote " + winnerVote);
                registerOracle(eventBytes32Id, mvuStake, winnerVote).then(function (result) {
                    if (String(result).includes('User denied transaction signature')) {
                        message.warning("Metamask transaction denied! Not registered as Oracle.");
                    } else {
                        return registerOracleApi(AuthStore.userAuth.auth.accessToken, eventBytes32Id, self.state.currentPropBet._id, web3Store.account, mvuStake, winnerVote).then(() => {
                            console.log("registerOracleApi finished");

                        });
                    }

                });
            }
        }
    }


    renderPropBetTypes() {
        let finalArray = [];
        let self = this;

        getPropEventsForEvent(this.props.eventId).then((betTypes) => {
            self.setState({ propBetTypes: betTypes });
            betTypes.forEach(betType => {
                finalArray.push(
                    self.renderBetsForOneType(betType))
            });
            if (finalArray.length > 0) {
                self.setState({ finalRender: finalArray })
            } else {
                self.setState({
                    finalRender: <div className="single-event-page-card-wagers-title">No Prop Bets Found</div>,
                    loaded: true,
                    loading: false
                });
            }
        }).catch((e) => {
            message.error(e);
            self.setState({
                finalRender: <div className="single-event-page-card-wagers-title">No Prop Bets Found</div>,
                loaded: true,
                loading: false
            });
        })


    }



    renderBetsForOneType(betType) {
        const { WagerStore } = this.props;
        const Panel = Collapse.Panel;

        const customPanelStyle = {
            background: '#11324a',
            borderRadius: 4,
            marginBottom: 10,
            borderBottom: "1px solid rgba(255,255,255,0)",
            overflow: 'hidden',
        };


        return <div>
            <br />
            <Collapse bordered={false} >
                {/* defaultActiveKey={['1']} */}
                <Panel default="closed" header={<div className="single-event-page-card-wagers-title">{betType.propTitle}
                <OracleRegNotice bytes32Id={betType.bytes32Id} /></div>} key="1" style={customPanelStyle}>

                    <div className="single-event-page-card-wagers-grid">
                        <div className="single-event-page-card-team-wagers">
                            {/* <div className="single-event-page-card-team-wagers-title">
                    
                       
                    </div> */}  <div className="single-event-page-cards-bet-options">
                                <Tooltip title={<span>Stake that this happened.</span>} >
                                    <button onClick={() => this.showOracleModal(1, betType)} className="single-event-page-cards-options-teamone">
                                        <span className="single-event-page-cards-bet-options-title">{betType.teams[0]}</span>
                                        {/* <div className="single-event-page-cards-bets-amount">{amountBetForTwo} ETH BET</div> */}
                                    </button>
                                </Tooltip>
                            </div>
                            {/* <div className="single-event-page-card-team-wagers-sort-options">
                    <div className="single-event-page-card-team-wagers-sort-options-sort">
                        <span className="single-event-page-card-team-wagers-sort-options-sort-title">Sort by:</span>
                        <button onClick={() => this.onTeamTwoWagerSortingMenuClick({ key: 1 })} className={this.state.sortTeamTwoWagersByValueAscending || this.state.sortTeamTwoWagersByValueDescending ? "custom-btn" : "custom-btn-primary"} style={{ fontSize: '10px', padding: '0px 5px 0px 5px', border: 'none' }}>
                            Potential Win {this.state.sortTeamTwoWagersByValueAscending ? <Icon type="up" /> : null}
                            {this.state.sortTeamTwoWagersByValueDescending ? <Icon type="down" /> : null}
                        </button>
                        <button onClick={() => this.onTeamTwoWagerSortingMenuClick({ key: 2 })} className={this.state.sortTeamTwoWagersByOddsAscending || this.state.sortTeamTwoWagersByOddsDescending ? "custom-btn" : "custom-btn-primary"} style={{ fontSize: '10px', padding: '0px 5px 0px 5px', border: 'none' }}>
                            Odds {this.state.sortTeamTwoWagersByOddsAscending ? <Icon type="up" /> : null}
                            {this.state.sortTeamTwoWagersByOddsDescending ? <Icon type="down" /> : null}
                        </button>
                        <button onClick={() => this.onTeamTwoWagerSortingMenuClick({ key: 3 })} className={this.state.sortTeamTwoWagersByPotentialWinAscending || this.state.sortTeamTwoWagersByPotentialWinDescending ? "custom-btn" : "custom-btn-primary"} style={{ fontSize: '10px', padding: '0px 5px 0px 5px', border: 'none' }}>
                            To Take {this.state.sortTeamTwoWagersByPotentialWinAscending ? <Icon type="up" /> : null}
                            {this.state.sortTeamTwoWagersByPotentialWinDescending ? <Icon type="down" /> : null}
                        </button>
                    </div>
                    <div className="single-event-page-card-team-wagers-sort-options-reset">
                        {
                            this.state.sortTeamTwoWagersByValueAscending || this.state.sortTeamTwoWagersByValueDescending || this.state.sortTeamTwoWagersByOddsAscending ||
                                this.state.sortTeamTwoWagersByOddsDescending || this.state.sortTeamTwoWagersByPotentialWinAscending ||
                                this.state.sortTeamTwoWagersByPotentialWinDescending ?
                                <button onClick={this.resetTeamTwoWagerSort} className="custom-btn-primary" style={{ fontSize: '10px', padding: '0px 5px 0px 5px', border: 'none' }}>Reset</button>
                                :
                                null
                        }
                    </div>
                </div> */}
                            {/* <div className="single-event-page-card-wagers-component">
                                teamTwoWagersComponent
                            </div> */}

                        </div>
                        <div className="single-event-page-card-team-wagers">
                            {/* <div className="single-event-page-card-team-wagers-title">{betType.teams[1]}
                        <button className="custom-btn-primary"
                            style={{ fontSize: '10px', padding: '0px 5px 0px 5px', border: 'solid', borderColor: "white", borderWidth: "1px" }}>Create Bet</button>
                    </div> */}

                            <div className="single-event-page-cards-bet-options">
                                <Tooltip title={<span>Stake that this happened.</span>} >
                                    {/* <a href="https://mevu.bet/fees">Full Fee Breakdown</a></span>}> */}


                                    <button onClick={() => this.showOracleModal(2, betType)} className="single-event-page-cards-options-teamtwo">
                                        <span className="single-event-page-cards-bet-options-title">{betType.teams[1]}</span>
                                        {/* <div className="single-event-page-cards-bets-amount">{amountBetForTwo} ETH BET</div> */}
                                    </button>
                                </Tooltip>
                            </div>
                            {/* <div className="single-event-page-card-team-wagers-sort-options">
                    <div className="single-event-page-card-team-wagers-sort-options-sort">
                        <span className="single-event-page-card-team-wagers-sort-options-sort-title">Sort by:</span>
                        <button onClick={() => this.onTeamOneWagerSortingMenuClick({ key: 1 })} className={this.state.sortTeamOneWagersByValueAscending || this.state.sortTeamOneWagersByValueDescending ? "custom-btn" : "custom-btn-primary"} style={{ fontSize: '10px', padding: '0px 5px 0px 5px', border: 'none' }}>
                            Potential Win {this.state.sortTeamOneWagersByValueAscending ? <Icon type="up" /> : null}
                            {this.state.sortTeamOneWagersByValueDescending ? <Icon type="down" /> : null}
                        </button>
                        <button onClick={() => this.onTeamOneWagerSortingMenuClick({ key: 2 })} className={this.state.sortTeamOneWagersByOddsAscending || this.state.sortTeamOneWagersByOddsDescending ? "custom-btn" : "custom-btn-primary"} style={{ fontSize: '10px', padding: '0px 5px 0px 5px', border: 'none' }}>
                            Odds {this.state.sortTeamOneWagersByOddsAscending ? <Icon type="up" /> : null}
                            {this.state.sortTeamOneWagersByOddsDescending ? <Icon type="down" /> : null}
                        </button>
                        <button onClick={() => this.onTeamOneWagerSortingMenuClick({ key: 3 })} className={this.state.sortTeamOneWagersByPotentialWinAscending || this.state.sortTeamOneWagersByPotentialWinDescending ? "custom-btn" : "custom-btn-primary"} style={{ fontSize: '10px', padding: '0px 5px 0px 5px', border: 'none' }}>
                            To Take {this.state.sortTeamOneWagersByPotentialWinAscending ? <Icon type="up" /> : null}
                            {this.state.sortTeamOneWagersByPotentialWinDescending ? <Icon type="down" /> : null}
                        </button>
                    </div>
                    <div className="single-event-page-card-team-wagers-sort-options-reset">
                        {
                            this.state.sortTeamOneWagersByValueAscending || this.state.sortTeamOneWagersByValueDescending || this.state.sortTeamOneWagersByOddsAscending ||
                                this.state.sortTeamOneWagersByOddsDescending || this.state.sortTeamOneWagersByPotentialWinAscending ||
                                this.state.sortTeamOneWagersByPotentialWinDescending ?
                                <button onClick={this.resetTeamOneWagerSort} className="custom-btn-primary" style={{ fontSize: '10px', padding: '0px 5px 0px 5px', border: 'none' }}>Reset</button>
                                :
                                null
                        }
                    </div>
                </div> */}
                            {/* <div className="single-event-page-card-wagers-component">
                                teamOneWagersComponent
                            </div> */}
                        </div>
                    </div>
                </Panel>
            </Collapse>
        </div>


    }





    render() {
        const { UserStore } = this.props;

        const oracleModal = <Modal
            isOpen={this.state.oracleModalVisible}
            onRequestClose={this.handleOracleCancel}
            className="custom-bet-modal"
            overlayClassName="custom-bet-modal-overlay"
        >


            <h3 className="single-event-oracle-titles">What happened?</h3>
            <h2>{this.state.currentPropBet.propTitle}</h2>
            <div style={{ textAlign: "center", display: "flex", flexDirection: "row", padding: "30px" }}>
                <Card onClick={this.oracleTeamOneClicked} bordered={false} style={{ background: this.state.oracleOneBackground, width: 300, padding: "30px" }}>
                    <h2 className="single-event-oracle-subtitles">{this.state.currentPropBet.teams[0]}</h2>

                </Card>
                <Card onClick={this.oracleTeamTwoClicked} bordered={false} style={{ background: this.state.oracleTwoBackground, width: 300, padding: "30px" }}>
                    <h2 className="single-event-oracle-subtitles">{this.state.currentPropBet.teams[1]}</h2>

                </Card>
            </div>
            <h3 className="single-event-oracle-titles">How much will you stake?</h3>
            <input onChange={(event) => {
                this.setState({ oracleStake: Number(event.target.value) })
            }} placeholder="1.000 MVU" />
            <br />
            <br />
            <button onClick={this.handleOracleCancel} className="custom-btn-danger">Exit</button>
            <button onClick={this.handleOracleOk} className="custom-btn-success">Submit</button>
        </Modal>



        return (<div>
            {oracleModal}
            {/* <br /> */}

            {/* <div className="single-event-page-card-wagers-title">Prop Bets</div> */}
            <br />
            {this.state.finalRender}
        </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/layoutComponents/OraclePropBets.js